import { STATUS } from '@/constants/status';

export type ColorPalette = 'success' | 'info' | 'warning' | 'secondary' | 'primary';

export const getColorPaletteForStatus = (status: string): ColorPalette => {
    switch (status) {
        case STATUS.NEW_RELEASE:
            return 'success';
        case STATUS.RELEASED:
            return 'secondary';
        case STATUS.IN_PROGRESS:
            return 'info';
        case STATUS.PLANNED:
            return 'warning';
        case STATUS.UNDER_CONSIDERATION:
            return 'primary';
        default:
            return 'primary';
    }
};
